var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.408,
    height: 18,
    viewBox: "0 0 20.408 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10 -15.9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M25.014,46.1h-3.1a.614.614,0,0,0-.612.612.6.6,0,0,0,.612.612h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-8.994 -24.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M53.114,46.1h-3.1a.614.614,0,0,0-.612.612.6.6,0,0,0,.612.612h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-31.359 -24.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M81.214,46.1h-3.1a.614.614,0,0,0-.612.612.6.6,0,0,0,.612.612h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-53.724 -24.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M25.014,59.5h-3.1a.614.614,0,0,0-.612.612.6.6,0,0,0,.612.612h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-8.994 -34.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M53.114,59.5h-3.1a.614.614,0,0,0-.612.612.6.6,0,0,0,.612.612h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-31.359 -34.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M81.214,59.5h-3.1a.614.614,0,0,0-.612.612.6.6,0,0,0,.612.612h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-53.724 -34.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M25.014,72.9h-3.1a.614.614,0,0,0-.612.612.6.6,0,0,0,.612.612h3.1a.612.612,0,1,0,0-1.224Z",
    transform: "translate(-8.994 -45.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M53.114,72.9h-3.1a.614.614,0,0,0-.612.612.6.6,0,0,0,.612.612h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-31.359 -45.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M81.214,72.9h-3.1a.614.614,0,0,0-.612.612.6.6,0,0,0,.612.612h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-53.724 -45.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M25.014,86.3h-3.1a.612.612,0,1,0,0,1.224h3.1a.612.612,0,1,0,0-1.224Z",
    transform: "translate(-8.994 -56.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M53.114,86.3h-3.1a.612.612,0,1,0,0,1.224h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-31.359 -56.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M81.214,86.3h-3.1a.612.612,0,1,0,0,1.224h3.1a.612.612,0,0,0,0-1.224Z",
    transform: "translate(-53.724 -56.033)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "calendarA",
    d: "M29.8,16.818H24.878v-.306a.612.612,0,1,0-1.224,0v.306H16.735v-.306a.612.612,0,1,0-1.224,0v.306h-4.9a.614.614,0,0,0-.612.612V33.288a.614.614,0,0,0,.612.612H29.8a.614.614,0,0,0,.612-.612V17.431A.614.614,0,0,0,29.8,16.818ZM16.143,19.39a.614.614,0,0,0,.612-.612v-.755h6.918v.755a.612.612,0,1,0,1.224,0v-.755h4.327v1.714H11.2V18.022h4.327v.755A.6.6,0,0,0,16.143,19.39ZM11.2,32.676V20.941h18V32.676Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.d56b315d.svg";
export { ForwardRef as ReactComponent };